// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__X_QR7"};